import AdminLink from "./AdminLink";

type NavigatorProps = {
  name?: string;
  page?: string;
  user?: any;
  onNavigate?: () => void;
};

export const Navigator = ({ name, page, user, onNavigate }: NavigatorProps) => {
  const role =
    user?.UserRole ||
    user?.Role ||
    user?.role ||
    user?.userRole ||
    user?.AccountType ||
    "Admin";

  const resolvedPage = page || role || "Admin";

  return (
    <AdminLink
      name={name}
      page={resolvedPage}
      roles={role}
      onNavigate={onNavigate}
    />
  );
};
